import script from "./HrFormSectionHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./HrFormSectionHeader.vue?vue&type=script&setup=true&lang=js"

import "./HrFormSectionHeader.vue?vue&type=style&index=0&id=d4e42a86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4e42a86"]])

export default __exports__